/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/TransactionLink.js
 */

import React from 'react';

const getLink = (data) =>
  `/#/search?query=transaction:${data.id}&facet="Transactions"`;

const TransactionLink = ({ data, type }) => {
  const date = new Date(data.date);
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <a href={getLink(data)}>
          <div className="Type">Transaction</div>
          <div className="Value">
            {`${data.type} on ${date.toLocaleDateString()}`}
          </div>
        </a>
      </div>
      <div className="SummaryLink">
        <a href={getLink(data)}>{getLink(data)}</a>
      </div>
      <div className="SummaryData">
        <p>
          Customer:{' '}
          {data.customer && data.customer.name
            ? data.customer.name
            : 'No customer associated with this transaction'}
        </p>
      </div>
    </div>
  );
};

export default TransactionLink;
